import {stopClickEvent} from "@lib/utils";
import {Popover} from "antd";
import {KeyIcon} from "@components/icons/Icons";
import React, {useEffect, useRef, useState} from "react";
import {TooltipPlacement} from "antd/lib/tooltip";

export const KeyIssueBadge = ({ keyInfo, windowDimensions, isLargeScreen, biggerClass = false}) => {
    const keyInfoRef = useRef<any>(null);
    const [keyInfoArrow, setKeyInfoArrow] = useState<TooltipPlacement>('top');
    useEffect(() => {
        if(windowDimensions && keyInfoRef && keyInfoRef.current){
            const threshold = windowDimensions.width - 150;
            const fromRight = keyInfoRef.current.getBoundingClientRect().right;
            setKeyInfoArrow((fromRight > threshold) ? 'topRight' : 'top');
        }
    }, [keyInfoRef, windowDimensions]);

    return (<div ref={keyInfoRef} className={biggerClass ? "valueBadge keyIssue isActive bigger" : "valueBadge keyIssue isActive"} onClick={stopClickEvent}>
        <Popover
            placement={keyInfoArrow}
            trigger={isLargeScreen ? ['hover','click'] : ['click']}
            content={<div className="keyInfoWrapper">{keyInfo}</div>}
        >
            <KeyIcon />
        </Popover>
    </div>);
};

export default KeyIssueBadge;